import { Signal } from '../signal';
import { signalTypes } from '../signal-types';
// event that is a signal
export class Event extends Signal {
    domain;
    signalName = 'event';
    constructor({ label, domain, attributes }) {
        super({
            label,
            attributes
        });
        this.setSignalType(signalTypes.EVENT);
        this.domain = domain;
    }
}
